export enum PaymentType {
  Paypal = 'paypal',
  CreditCard = 'credit-card',
  BankTransfer = 'bank-transfer',
}
